import L from 'leaflet';
import sendToPointCallback from './sendToPointCallback';

/**
 * Adds a layer for the markers when sending a waypoint away.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.leafletMap - The leaflet map object.
 * @param {?object} [arg.sendToPointMarkerLayer] - The layer where the marker will be painted.
 * @param {Function} arg.getCurrentMapState - A function that gets the current variables needed from the map component.
 * @returns {object} The leaflet layers where the markers are painted.
 */
const sendToPointAction = ({ leafletMap, getCurrentMapState }) => {
  const sendToPointMarkerLayer = new L.LayerGroup();
  sendToPointMarkerLayer.addTo(leafletMap);
  leafletMap.on('click', event => sendToPointCallback({ getCurrentMapState, event }));
  return sendToPointMarkerLayer;
};

export default sendToPointAction;
